import { FC } from 'react';
import { CallIntelTypes } from '@frontend/api-call-intel';
import { DropDownMultiFilterSelector } from '@frontend/analytics-shared';
import { useOptionsProvider } from '@frontend/call-intel-core';
import { useTranslation } from '@frontend/i18n';
import { trackingIds } from '../../../../tracking-ids';
import { useCallIntelFiltersContext } from '../context/call-intel-filters.context';
import { FilterTraySection } from './filter-tray-section/filter-tray-section';

export const CategoryFilterTray: FC<{ showClear?: boolean }> = ({ showClear = true }) => {
  const { t } = useTranslation('call-intelligence');
  const { filterValues, updateFilterValues } = useCallIntelFiltersContext();
  const { getOptions } = useOptionsProvider();

  return (
    <FilterTraySection
      label={t('Category')}
      showClear={showClear}
      onClear={() => updateFilterValues({ categories: [] })}
    >
      <DropDownMultiFilterSelector
        label={t('Select Categories')}
        onChange={(value) => updateFilterValues({ categories: value as CallIntelTypes.CategoryEnum[] })}
        options={getOptions('categories', 'array')}
        trackingId={trackingIds.callIntel.categoriesFilter}
        value={filterValues.categories}
      />
    </FilterTraySection>
  );
};
